import { put, takeLatest, all, call } from 'redux-saga/effects';
import axios from 'axios';
import dayjs from 'dayjs';

import { heliumReceive } from 'utils/helpers';

import { integrationActions } from '../slices/integrationSlice';

function* fetchIntegrationStatusSaga(
  action: ReturnType<typeof integrationActions.fetchIntegrationStatus>,
): Generator {
  const { orgId } = action.payload;

  try {
    const integrationData = yield call(heliumReceive, 'getIntegrationMsiAlta', [
      orgId,
    ]);

    if (!integrationData.data || integrationData.data.length === 0) {
      yield put(
        integrationActions.setIntegrationStatus({
          isMsiIntegrated: false,
          isGuestPassIntegrated: false,
          isTokenValid: false,
        }),
      );
      return;
    }

    const initialData = integrationData.data[0];
    const { msiAltaOrgId, msiAltaToken, msiAltaTokenExpUtc, guestPassEnabled } =
      initialData;

    const hasOrgId = !!msiAltaOrgId;
    const hasToken = !!msiAltaToken;
    const tokenIsValidDate =
      !msiAltaTokenExpUtc || dayjs.utc(msiAltaTokenExpUtc).isAfter(dayjs.utc());
    const guestPassEnabledCondition = guestPassEnabled === 1;
    const msiAltaApiHost =
      initialData.msiAltaApiHost || 'https://api.openpath.com';

    let isTokenValid = false;

    if (hasOrgId && hasToken && tokenIsValidDate) {
      try {
        const response = yield call(
          axios.post,
          `${msiAltaApiHost}/auth/accessTokens/${msiAltaToken}/validate`,
        );
        isTokenValid = response.data?.data?.isValid || false;
      } catch {
        isTokenValid = false;
      }
    }

    yield put(
      integrationActions.setIntegrationStatus({
        isMsiIntegrated: hasOrgId && hasToken && tokenIsValidDate,
        isGuestPassIntegrated:
          hasOrgId && hasToken && tokenIsValidDate && guestPassEnabledCondition,
        isTokenValid,
      }),
    );
  } catch {
    yield put(
      integrationActions.setError('Failed to fetch integration status'),
    );
  } finally {
    yield put(integrationActions.setLoading(false));
  }
}

export default function* integrationSaga(): Generator {
  yield all([
    takeLatest(
      integrationActions.fetchIntegrationStatus.type,
      fetchIntegrationStatusSaga,
    ),
  ]);
}
